import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  paper: {
    marginTop: 24,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    padding: 10,
    maxHeight: 'calc(75vh - 150px)',
  },
  gridConatiner: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    maxHeight: '100%',
    gap: 20,
    alignItems: 'center',
  },
  gridItem: {
    padding: 15,
    textAlign: 'center',
    display: 'flex',
    height: 70,
  },
};

export default styles;
